import getDateRanges from './getDateRanges';

export const getCalendarHistorySelection = (dateRange, now = new Date()) => {
  const preset = dateRange?.[2];
  if (preset) {
    if (!['today', 'yesterday', 'this-week', 'last-week', 'this-month', 'last-month'].includes(preset.period)) {
      throw new Error('Invalid history preset');
    }
    const reference = Math.floor(new Date(preset.now).getTime() / 1000);
    if (!Number.isSafeInteger(reference)) throw new Error('Invalid history reference time');
    return { preset: preset.period.replace('-', '_'), reference_time: reference };
  }
  const calendar = (value) => {
    if (!value) throw new Error('A history date range is required');
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) throw new Error('Invalid history date');
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };
  const start = calendar(dateRange?.[0]);
  const end = calendar(dateRange?.[1]);
  const valid = (value) => {
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value &&
      Number(value.slice(0, 4)) >= 1000;
  };
  const days = (Date.parse(end) - Date.parse(start)) / 86400000 + 1;
  if (!valid(start) || !valid(end) || days < 1 || days > 366) throw new Error('Invalid history date range (maximum 366 days)');
  return { start_date: start, end_date: end, reference_time: Math.floor(new Date(now).getTime() / 1000) };
};

// V2 resolves presets in each business's zone, not the dispatcher's zone.
// The third array entry survives React Query serialization.
export const historyDateRanges = (now = new Date()) =>
  Object.fromEntries(
    Object.entries(getDateRanges(now)).map(([period, range]) => [
      period,
      [...range, { period, now: new Date(now).toISOString() }],
    ])
  );
